import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../../../firebase/config';
import { collection, addDoc, getDocs, updateDoc, deleteDoc, doc } from 'firebase/firestore';

const AdminRiesgos = () => {
    const navigate = useNavigate();
    const [riesgos, setRiesgos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [isEditing, setIsEditing] = useState(null);

    // Estado del Formulario
    const [formData, setFormData] = useState({
        nombre: '', // Ej: Automotores
        grupo: 'PATRIMONIALES', // PATRIMONIALES o ART
        subriesgos: [] // Array de strings: ['Individual', 'Flota']
    });

    const riesgosRef = collection(db, 'public/data/riesgos');

    const fetchData = async () => {
        setLoading(true);
        try {
            const snap = await getDocs(riesgosRef);
            const data = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            data.sort((a, b) => a.nombre.localeCompare(b.nombre));
            setRiesgos(data);
        } catch (error) { console.error(error); } 
        finally { setLoading(false); }
    };

    useEffect(() => { fetchData(); }, []);

    // --- MANEJO DEL MODAL ---
    const handleOpenModal = (item = null) => {
        if (item) {
            setFormData({ ...item, subriesgos: item.subriesgos || [] });
            setIsEditing(item.id);
        } else {
            setFormData({ nombre: '', grupo: 'PATRIMONIALES', subriesgos: [''] });
            setIsEditing(null);
        }
        setShowModal(true);
    };

    const handleSave = async (e) => {
        e.preventDefault();
        try {
            const subriesgosLimpios = formData.subriesgos.filter(s => s.trim() !== '');
            const payload = { ...formData, subriesgos: subriesgosLimpios };
            
            if (isEditing) await updateDoc(doc(db, 'public/data/riesgos', isEditing), payload);
            else await addDoc(riesgosRef, payload);
            
            setShowModal(false);
            fetchData();
        } catch (error) { alert("Error al guardar riesgo"); }
    };

    const handleDelete = async (id) => {
        if (window.confirm("¿Eliminar este riesgo?")) {
            await deleteDoc(doc(db, 'public/data/riesgos', id));
            fetchData();
        }
    };

    // --- ARRAY SUBRIESGOS ---
    const handleSubChange = (idx, val) => {
        const newArr = [...formData.subriesgos];
        newArr[idx] = val;
        setFormData({ ...formData, subriesgos: newArr });
    };
    const addSub = () => setFormData({ ...formData, subriesgos: [...formData.subriesgos, ''] });
    const removeSub = (idx) => setFormData({ ...formData, subriesgos: formData.subriesgos.filter((_, i) => i !== idx) });

    return (
        <div className="p-8 bg-gray-50 min-h-screen font-sans text-gray-800">
            <div className="max-w-5xl mx-auto">
                <div className="flex justify-between items-center mb-8">
                    <div>
                        <h1 className="text-3xl font-extrabold text-gray-900 tracking-tight">Riesgos y Subriesgos</h1>
                        <p className="text-gray-500 mt-1">Define los productos asegurables del sistema.</p>
                    </div>
                    <div className="flex gap-3">
                        <button onClick={() => navigate('/AdminDashboard')} className="bg-white border border-gray-300 text-gray-700 px-4 py-2 rounded-lg font-bold shadow-sm hover:bg-gray-50 transition text-sm">Volver</button>
                        <button onClick={() => handleOpenModal()} className="bg-indigo-600 text-white px-5 py-2 rounded-lg font-bold shadow hover:bg-indigo-700 text-sm flex gap-2 items-center">+ Nuevo Riesgo</button>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {riesgos.map(r => (
                        <div key={r.id} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden hover:shadow-md transition">
                            <div className="p-4 border-b border-gray-100 flex justify-between items-center bg-gray-50">
                                <h3 className="font-bold text-gray-800">{r.nombre}</h3>
                                <div className="flex gap-2">
                                    <button onClick={() => handleOpenModal(r)} className="text-blue-500 hover:text-blue-700"><svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.536l12.232-12.232z"></path></svg></button>
                                    <button onClick={() => handleDelete(r.id)} className="text-red-400 hover:text-red-600"><svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg></button>
                                </div>
                            </div>
                            <div className="p-4">
                                <span className={`text-[10px] font-bold px-2 py-1 rounded uppercase mb-3 inline-block ${r.grupo === 'ART' ? 'bg-orange-100 text-orange-700' : 'bg-green-100 text-green-700'}`}>{r.grupo}</span>
                                <div className="flex flex-wrap gap-2">
                                    {r.subriesgos && r.subriesgos.length > 0 ? (
                                        r.subriesgos.map((sr, i) => (
                                            <span key={i} className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded border border-gray-200">{sr}</span>
                                        ))
                                    ) : <span className="text-xs text-gray-400 italic">Sin subriesgos</span>}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* MODAL */}
            {showModal && (
                <div className="fixed inset-0 bg-gray-900 bg-opacity-60 flex items-center justify-center p-4 z-50">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden animate-fade-in">
                        <div className="bg-indigo-600 px-6 py-4 flex justify-between items-center text-white">
                            <h3 className="font-bold text-lg">{isEditing ? 'Editar Riesgo' : 'Nuevo Riesgo'}</h3>
                            <button onClick={() => setShowModal(false)} className="hover:text-gray-200">✕</button>
                        </div>
                        <form onSubmit={handleSave} className="p-6 space-y-6">
                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <label className="text-xs font-bold text-gray-500 uppercase tracking-wide block mb-1">Nombre Riesgo</label>
                                    <input type="text" value={formData.nombre} onChange={(e) => setFormData({...formData, nombre: e.target.value})} className="w-full border border-gray-300 p-2 rounded-lg outline-none focus:border-indigo-500" required placeholder="Ej: Automotores" />
                                </div>
                                <div>
                                    <label className="text-xs font-bold text-gray-500 uppercase tracking-wide block mb-1">Grupo</label>
                                    <select value={formData.grupo} onChange={(e) => setFormData({...formData, grupo: e.target.value})} className="w-full border border-gray-300 p-2 rounded-lg outline-none bg-white">
                                        <option value="PATRIMONIALES">PATRIMONIALES</option>
                                        <option value="ART">ART</option>
                                    </select>
                                </div>
                            </div>

                            <div className="bg-gray-50 p-4 rounded-xl border border-gray-200">
                                <div className="flex justify-between items-center mb-3">
                                    <h4 className="text-sm font-bold text-gray-700">Subriesgos</h4>
                                    <button type="button" onClick={addSub} className="text-xs bg-indigo-100 text-indigo-700 px-3 py-1 rounded font-bold hover:bg-indigo-200 transition">+ Agregar</button>
                                </div>
                                <div className="space-y-2 max-h-48 overflow-y-auto pr-2 custom-scrollbar">
                                    {formData.subriesgos.map((sub, idx) => (
                                        <div key={idx} className="flex gap-2">
                                            <input type="text" value={sub} onChange={(e) => handleSubChange(idx, e.target.value)} className="flex-grow border border-gray-300 rounded p-1.5 text-sm outline-none" placeholder="Ej: Individual" />
                                            <button type="button" onClick={() => removeSub(idx)} className="text-red-400 hover:text-red-600 px-2 font-bold">✕</button>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="flex justify-end gap-3 pt-2">
                                <button type="button" onClick={() => setShowModal(false)} className="px-4 py-2 rounded-lg border border-gray-300 text-gray-600 font-bold hover:bg-gray-50 text-sm">Cancelar</button>
                                <button type="submit" className="px-6 py-2 rounded-lg bg-indigo-600 text-white font-bold hover:bg-indigo-700 shadow text-sm">Guardar</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminRiesgos;